import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const useGetStockStatusLabel = (identifier, quantity1)=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    return React.useMemo(()=>{
        const labelMap = {
            'in-stock': ()=>getLabel('common.stockIndicator.inStock')
            ,
            'in-stock-with-quantity': (quantity)=>{
                return getFormattedLabel('common.stockIndicator.inStockWithQuantity', {
                    labelData: {
                        quantity: quantity === null || quantity === void 0 ? void 0 : quantity.toString()
                    }
                });
            },
            'low-stock': ()=>getLabel('common.stockIndicator.lowStock')
            ,
            'low-stock-with-quantity': (quantity)=>{
                return getFormattedLabel('common.stockIndicator.lowStockWithQuantity', {
                    labelData: {
                        quantity: quantity === null || quantity === void 0 ? void 0 : quantity.toString()
                    }
                });
            },
            'out-of-stock': ()=>getLabel('common.stockIndicator.outOfStock')
            ,
            'out-of-stock-with-back-order': ()=>getLabel('common.stockIndicator.backOrder')
            ,
            'unknown-stock': ()=>getLabel('common.stockIndicator.unknownStock')
        };
        const label = labelMap[identifier];
        return label(quantity1);
    }, [
        getFormattedLabel,
        getLabel,
        quantity1,
        identifier
    ]);
};

export { useGetStockStatusLabel };
//# sourceMappingURL=useGetStockStatusLabel.js.map
